import { createStyles } from '@mantine/core'

export default createStyles(() => {
  return {
    heading: {
      textAlign: 'center',
    },
    description: {
      textAlign: 'center',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      alignItems: 'center',
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      alignItems: 'center',
    },
    img: {
      height: 160,
    },
    button: {},
  }
})
